import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PagesComponent } from "./pages.component";
import { SyncComponent } from "./Sync/Sync.component";
import { LoginComponent } from "./login/login.component";
import { AuthGuard } from '../auth/auth.guard'; 

const routes: Routes = [
  {
    path: "",
    component: PagesComponent,
    children: [
      // { path: "Sync",component: LoginComponent},
      // {
      //   path: "**",
      //   redirectTo: "Sync",
      // }
      // 1. 根路徑直接導到 /login
      { path: '', redirectTo: 'login', pathMatch: 'full' },

      // 2. login 頁面
      { path: 'login', component: LoginComponent },

      // 3. sync 頁面，加入 canActivate
      {
        path: 'Sync',
        component: SyncComponent,
        canActivate: [AuthGuard]
      },

      // 4. 其它不認得的路由都導到 /login
      { path: '**', redirectTo: 'login' }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesRoutingModule { }
